import { render, staticRenderFns } from "./relationsSuggestions.vue?vue&type=template&id=6c87dacd&scoped=true&"
import script from "./relationsSuggestions.vue?vue&type=script&lang=js&"
export * from "./relationsSuggestions.vue?vue&type=script&lang=js&"
import style0 from "./relationsSuggestions.vue?vue&type=style&index=0&id=6c87dacd&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c87dacd",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/corp-dev.1clicom.ru/laravel/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6c87dacd')) {
      api.createRecord('6c87dacd', component.options)
    } else {
      api.reload('6c87dacd', component.options)
    }
    module.hot.accept("./relationsSuggestions.vue?vue&type=template&id=6c87dacd&scoped=true&", function () {
      api.rerender('6c87dacd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/global/RelationsSearch/relationsSuggestions.vue"
export default component.exports